module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAMAAACtdX32AAAAQlBMVEWaHEwAM6sKO64OPrARQbETQrEXRbMfTLUqVbkrVbk0XbxGa8JKbsNNccRbfMlmhc1ohs1/mdWart6imkrPFCv30Rfv3UDDAAAAAXRSTlPhl+sKiAAAAFNJREFUeNrNyUkKwCAQRFHbeWyHJPe/agghIiidrX9TBY9dZDvzQcZgLHofYWzkghgCYlmySs4+a11SC9ZNvEc0PbOp/Lu8mollhl6WnX86yTbmG6LGIQ9pENykAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/ve.png
// module id = 956
// module chunks = 0